import { Pipe, PipeTransform } from '@angular/core';
import {
  CultureKeyType,
  FALLBACK_CULTURE,
  DURATION_FORMAT_BY_CULTURE,
} from '@constants/app.constants';
import { Duration } from 'luxon';

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(
    millis: number,
    culture: CultureKeyType = FALLBACK_CULTURE,
  ): string {
    const format = DURATION_FORMAT_BY_CULTURE[culture];
    return Duration.fromMillis(millis).toFormat(format);
  }
}
